import React from 'react';
import styled from 'react-emotion';
import { Column, Row } from '~/modules/coreUI/components/layouts/helpers/LinearLayout';
import Separator from '~/modules/coreUI/components/layouts/helpers/Separator';

export const FullWidthColumn = props => <Column {...props} fullWidth />;

export const GridArea = styled(FullWidthColumn)`
  grid-area: ${props => props.gridArea};
  justify-self: ${props => props.justify};
`;

export const ProductDetailsVerticalSeparator = props => (
  <Row fullWidth fullHeight>
    <Separator {...props} vertical separatorLength="full" />
  </Row>
);

export const ProductDetailsHorizontalSeparator = props => (
  <Column fullWidth fullHeight>
    <Separator {...props} separatorLength="full" />
  </Column>
);
